import { render, staticRenderFns } from "./AcademicProgram.vue?vue&type=template&id=8dbb9168"
import script from "./AcademicProgram.vue?vue&type=script&lang=js"
export * from "./AcademicProgram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports